module.exports = __webpack_public_path__ + "static/media/MCO.dcb3858b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/MCO.jpg
// module id = 1766
// module chunks = 1